import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterPaymentType } from './z-printer-payment-type';

@MappedClass()
export class ZPrinterPaymentTypeApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedProperty()
  value: ZPrinterPaymentType;
}
